// extracted by mini-css-extract-plugin
export default {"top":"HeaderOrders_top__CniXS","box":"HeaderOrders_box__ENImn","addButton":"HeaderOrders_addButton__nCXQK"};